import { Box, Drawer } from '@mui/material';
import { bool, object, string } from 'prop-types';
import React, { memo } from 'react';
import employeeShape from 'shapes/employee';
import CloseButton from '../CloseButton';
import connector from './connector';
import EmployeeForm from './Form';

const EmployeeDrawer = ({ actions, employee = null, employeeId = null, isEdit, isOpen }) => {
  const handleClose = () => {
    actions.employeeDrawer.close();
  };

  if (!isOpen) return null;

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose}>
      <Box
        sx={theme => ({
          display: 'flex',
          width: '100%',
          [theme.breakpoints.up('md')]: {
            width: 900,
          },
        })}
      >
        <Box sx={{ pt: '20px', pl: '20px' }}>
          <CloseButton onClick={handleClose} />
        </Box>
        <EmployeeForm isEdit={isEdit} employee={employee} employeeId={employeeId} />
      </Box>
    </Drawer>
  );
};

EmployeeDrawer.propTypes = {
  employee: employeeShape,
  employeeId: string,
  isOpen: bool.isRequired,
  isEdit: bool.isRequired,
  actions: object.isRequired,
};

const areEqual = (prevProps, nextProps) =>
  prevProps.company?.teams?.length === nextProps.company?.teams?.length &&
  prevProps.employee?._id === nextProps.employee?._id &&
  prevProps.employee?.loading === nextProps.employee?.loading &&
  prevProps.employee?.channels?.length === nextProps.employee?.channels?.length &&
  prevProps.employee?.user_id === nextProps.employee?.user_id &&
  prevProps.employee?.user?._id === nextProps.employee?.user?._id &&
  prevProps.isOpen === nextProps.isOpen &&
  prevProps.isEdit === nextProps.isEdit;

export default connector(memo(EmployeeDrawer, areEqual));
